import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, useMediaQuery, useTheme } from '@mui/material';
import BDrawer from '@ui/components/common/BDrawer';
import CustomDialog from '@ui/components/common/Dialog';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import AddNewRelationForm from './AddNewRelationForm';
import { Box } from '@mui/material';
const AddNewRelationDialog = ({ open, onClose, edit = false, relationId }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
    const formRef = useRef(null);
    const handleSubmit = () => {
        if (formRef.current) {
            formRef.current.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
    };
    const title = edit ? t('relations.editRelation') : t('relations.addNewRelation');
    const submitButtonText = edit ? t('actions.editNow') : t('actions.addNow');
    if (isMobile) {
        return (_jsx(BDrawer, { open: open, onClose: onClose, title: title, dialogActions: _jsx(_Fragment, { children: _jsxs(Box, { p: 1.5, children: [_jsx(Button, { fullWidth: true, onClick: onClose, variant: 'outlined', size: 'large', children: t('actions.cancel') }), _jsx(Button, { fullWidth: true, variant: 'contained', color: 'inherit', size: 'large', onClick: handleSubmit, children: submitButtonText })] }) }), children: _jsx(AddNewRelationForm, { onClose: onClose, formRef: formRef, edit: edit, relationId: relationId }) }));
    }
    return (_jsx(CustomDialog, { backgroundVariant: 'white', open: open, onClose: onClose, titleWithIcon: title, titleIcon: '/assets/images/add-person.png', maxWidth: 'sm', actions: _jsxs(_Fragment, { children: [_jsx(Button, { fullWidth: true, onClick: onClose, variant: 'outlined', color: 'inherit', size: 'large', children: t('actions.cancel') }), _jsx(Button, { fullWidth: true, variant: 'contained', color: 'inherit', size: 'large', onClick: handleSubmit, children: submitButtonText })] }), children: _jsx(Box, { p: 1.5, sx: isDesktop
                ? {
                    maxHeight: '65vh',
                    overflowY: 'auto'
                }
                : undefined, children: _jsx(AddNewRelationForm, { onClose: onClose, formRef: formRef, edit: edit, relationId: relationId }) }) }));
};
export default AddNewRelationDialog;
